window.addEventListener('DOMContentLoaded', function () {
  function tubsClick(tabs, contents) {
      for (let i = 0; i < tabs.length; i++) {
          tabs[i].addEventListener('click', () => {
              for (let t = 0; t < tabs.length; t++) {
                  tabs[t].classList.remove('tabs__nav-item--active');
                  contents[t].classList.remove('tabs__body-item--active');
              }
              tabs[i].classList.add('tabs__nav-item--active');
              contents[i].classList.add('tabs__body-item--active');
              // modalClose(tabs[i]);
          });
      }
  }

  const optimalCombinationTabs = document.getElementById('optimalCombination')?.querySelectorAll(".tabs__nav-item");
  const optimalCombinationContents = document.getElementById('optimalCombination')?.querySelectorAll(".tabs__body-item");

  const recommendationsDryWetTabs = document.getElementById('recommendationsDryWet')?.querySelectorAll(".tabs__nav-item");
  const recommendationsDryWetContents = document.getElementById('recommendationsDryWet')?.querySelectorAll(".tabs__body-item");

  if (optimalCombinationTabs) {
      tubsClick(optimalCombinationTabs, optimalCombinationContents);
  }

  if (recommendationsDryWetTabs) {
      tubsClick(recommendationsDryWetTabs, recommendationsDryWetContents);
  }

  const btnOpenModal = document.querySelectorAll('.tabs__modal-btn');
  if (btnOpenModal) {
      btnOpenModal.forEach((item) => {
          item.addEventListener('click', () => {
              if (window.innerWidth < 768) {
                  modalOpen(item);
              }
          });
      });

      const btnCloseModal = document.querySelectorAll('.tabs__modal-close');
      btnCloseModal.forEach((item) => {
          item.addEventListener('click', () => {
              modalClose(item);
          });
      });
  }

  function modalOpen(el) {
      const modal = el.closest('.tabs__header').querySelector('.tabs__modal');
      modal.classList.add('tabs__modal--show');
      document.querySelector('body').classList.add('overflow');
  }

  function modalClose(el) {
      const modal = el.closest('.tabs__modal');
      modal.classList.remove('tabs__modal--show');
      document.querySelector('body').classList.remove('overflow');
  }
});
